import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { connect } from "react-redux";

import { Container, Row, Col, Card, CardBody } from 'reactstrap';

import { isUserAuthenticated } from '../../../helpers/authUtils';
import LoaderWidget from '../../../components/Loader';
import logo from '../../../assets/images/AerCap_logo_RGB_White.png';

import LoginForm from "./LoginForm";
import ChangePasswordForm from "./ChangePasswordForm";
import PasswordChangeResult from "./PasswordChangeResult";

import { fetchJSON } from '../../../helpers/api';

import { showPasswordChange, hidePasswordChange, setPasswordChangeComplete, unsetPasswordChangeComplete, setUsername } from "../../../redux/auth/actions";

class Login extends Component {
    _isMounted = false;

    constructor(props) {
        super(props);

        this.state = {
            loading: false,
            error: false,
            errorMessage: '',
            environment: 'NOT SET',
            showPassword: false,
            showMaintenanceMessageAndBlockLogin: 'N'
        };

        this.clearState = this.clearState.bind(this);
        this.getEnvironment = this.getEnvironment.bind(this);
        this.showMaintenanceMessage = this.showMaintenanceMessage.bind(this);
    }

    componentDidMount() {
        this._isMounted = true;
        this.getEnvironment();
        this.showMaintenanceMessage();
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    clearState = () => {
        // clear the state to default
        this.setState({
            loading: false,
            success: false,
            successMessage: '',
            error: false,
            errorMessage: ''
        });

        this.props.hidePasswordChange();
        this.props.unsetPasswordChangeComplete();
    };


    /**
     * Redirect to root
     */
    renderRedirectToRoot = () => {
        const isAuthTokenValid = isUserAuthenticated();
        if (isAuthTokenValid) {
            return <Redirect to="/" />;
        }
    };

    async getEnvironment() {
        let url = `/portal/Auth/GetEnvironment`;
        let response = await fetchJSON(url);
        this.setState({ environment: response.data });
    }

    async showMaintenanceMessage() {
        
        let url = '/portal/Miscellaneous/ShowMaintenanceMessage';
        let response = await fetchJSON(url);
        this.setState({ showMaintenanceMessageAndBlockLogin: response.data });
    };  

    render() {
        const isAuthTokenValid = isUserAuthenticated();
        const showPassword = () => {
            this.setState({
                showPassword: true
            });
        };

        const hidePassword = () => {
            this.setState({
                showPassword: false
            });
        };

        return (
            <React.Fragment>
                {this.renderRedirectToRoot()}

                {(this._isMounted || !isAuthTokenValid) && (
                    <div className="account-pages mt-5 mb-5">
                        <Container>
                            <Row className="justify-content-center">
                                <Col lg={5}>
                                    <Card>
                                        <div className="auth-card-header pt-2 text-center">
                                            <img src={logo} alt="" height="130" />
                                        </div>
                                        <span className="environmentText">{this.state.environment}</span>
                                        <CardBody className="p-4 position-relative">
                                            {!this.props.changePasswordVisible && !this.props.changePasswordComplete && (
                                                
                                                <LoginForm
                                                    successMessage={this.state.successMessage}
                                                    errorMessage={this.state.errorMessage}
                                                    login={this.login}
                                                    passwordVisible={this.state.showPassword}
                                                    showPassword={showPassword}
                                                    hidePassword={hidePassword}
                                                    showMaintenanceMessageAndBlockLogin={this.state.showMaintenanceMessageAndBlockLogin} />
                                            )}

                                            {this.props.changePasswordVisible && (
                                                <React.Fragment>
                                                    {/* preloader */}
                                                    {this.state.loading && <LoaderWidget />}

                                                    <ChangePasswordForm
                                                        successMessage={this.state.successMessage}
                                                        errorMessage={this.state.errorMessage}
                                                        username={this.props.username}
                                                        sessionId={this.props.sessionId}
                                                        changePasswordVisible={this.props.changePasswordVisible}
                                                    />
                                                </React.Fragment>
                                                
                                            )}
                                            
                                            {this.props.changePasswordComplete && (
                                                
                                                <React.Fragment>
                                                    {/* preloader */}
                                                    {this.state.loading && <LoaderWidget />}
                                                    
                                                    <PasswordChangeResult
                                                        errorMessage={this.state.errorMessage}
                                                        username={this.props.username}
                                                        clearState={this.clearState}
                                                    />

                                                    </React.Fragment>
                                                
                                            )}

                                        </CardBody>
                                    </Card>
                                </Col>
                            </Row>
                        </Container>
                    </div>
                )}
            </React.Fragment>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        username: state.Auth.username,
        sessionId: state.Auth.sessionId,
        changePasswordVisible: state.Auth.changePasswordVisible,
        changePasswordComplete: state.Auth.changePasswordComplete
    };
};

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        updateUsername: (username) => {
            dispatch(setUsername(username));
        },
        activateChangePassword: () => {
            dispatch(showPasswordChange());
        },
        hidePasswordChange: () => {
            dispatch(hidePasswordChange());
        },
        setPasswordChangeComplete: () => {
            dispatch(setPasswordChangeComplete());
        },
        unsetPasswordChangeComplete: () => {
            dispatch(unsetPasswordChangeComplete());
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Login);
